import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import "../styles/Login.css";
import backgroundVideo from "../assets/login.mp4"
// ✅ Only admin credentials (no normal users)
const ADMIN_CREDENTIALS = [
  { username: btoa('sample@niveshly.com'), password: btoa('sample@123') },
  { username: btoa('Admin'), password: btoa('Unlisted@2025') },
  { username: btoa('MridulGrover'), password: btoa('Unlisted@2025') },

];

const Login = ({ onLoginSuccess }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();

    const encodedUsername = btoa(username);
    const encodedPassword = btoa(password);

    const isAdmin = ADMIN_CREDENTIALS.some(
      (cred) => cred.username === encodedUsername && cred.password === encodedPassword
    );

    if (isAdmin) {
      // ✅ Save admin role for navbar visibility
      localStorage.setItem("role", "admin");

      onLoginSuccess?.(); // optional callback
      navigate('/manage'); // redirect to admin dashboard or manage page
    } else {
      setError('Access denied. Admin only.');
    }
  };

  // Split the welcome text into individual letters for animation
  const welcomeText = "WELCOME TO Niveshly Admin Panel".split('');

  return (
    <div className="login-container">
      <video className="background-video" autoPlay loop muted playsInline>
        <source src={backgroundVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      <div className="login-image-section">
        <div className="welcome-text-container">
          <h1 className="welcome-text">
            {welcomeText.map((char, index) => (
              <span
                key={index}
                className="welcome-text-letter"
                style={{ animationDelay: `${index * 0.05}s` }}
              >
                {char}
              </span>
            ))}
          </h1>
        </div>
      </div>

      <div className="login-form-section">
        <div className="form-wrapper">
          <h2 className="form-title">Niveshly Admin View</h2>
          <p className="form-subtitle">Admin access only</p>

          <form onSubmit={handleLogin}>
            <div className="input-group">
              <label htmlFor="username">Username</label>
              <input
                id="username"
                type="text"
                placeholder="Enter admin email"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </div>

            <div className="input-group">
              <label htmlFor="password">Password</label>
              <input
                id="password"
                type="password"
                placeholder="············"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>

            <button type="submit" className="login-button">
              Sign In
            </button>

            {error && <p className="error-message">{error}</p>}
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
